import { useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from 'lib/react-query';
import { getDetailedWorkflow } from 'apis/workflow/losAPI';
import { useSnackbar } from 'notistack';

export const useDetailedWorkflow = (workflowId, config = {}) => {
	return useQuery({
		...config,
		queryKey: ['los-workflows', workflowId],
		queryFn: () => getDetailedWorkflow({ workflowId }),
	});
};
